import { Box } from '@pocketlaw/tetris';
import { AuthenticationModeSelect } from './AuthenticationModeSelect';
import { RoleSelect } from './RoleSelect';
export function RoleAndAuth(props) {
    const { disableRole } = props;
    return (<Box gap="inherit">
      <RoleSelect disabled={disableRole}/>
      <AuthenticationModeSelect />
    </Box>);
}
